var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Money } from "./../../../Primitives/Money";
export class TurnOver {
  constructor(_data) {
    /**
     */
    __publicField(this, "Amount");
    /**
     */
    __publicField(this, "Year");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof TurnOver
     */
    __publicField(this, "$type", "V1.CompanyInfo.Questionnaire.Answers.TurnOver");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["Amount"]) {
        const amount_ = new Money();
        this.Amount = amount_.init(_data["Amount"]);
      }
      this.Year = _data["Year"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Amount"] = this.Amount ? this.Amount.toJSON() : void 0;
    _data["Year"] = this.Year;
    return _data;
  }
}
